export default "__VITE_ASSET__8UqRzpfc__"